<div class="wheel-history">
  <div class="wheel-history--title">Past 20:</div>
  <div class="wheel-history--colors small">
    @for (color of wheelService.history().slice(0, 20); track $index) {
    <div class="wheel-history--color {{ color.color }}"></div>
    }
  </div>
</div>
<div class="wheel-history">
  <div class="wheel-history--title">Last 100:</div>
  <div class="wheel-history--colors all">
    @for (color of colors; track $index) {
    <div class="wheel-history--colors__item">
      <div class="wheel-history--color {{ color }}"></div>
      <span class="wheel-history--colors__quantity {{ color }}">
        @if (color === 'gold') {
        {{ wheelService.last100Bets().gold }}
        } @else if (color === 'red') {
        {{ wheelService.last100Bets().red }}
        } @else if (color === 'blue') {
        {{ wheelService.last100Bets().blue }}
        } @else if (color === 'gray') {
        {{ wheelService.last100Bets().gray }}
        } @else if (color === 'gold') {
        {{ wheelService.last100Bets().gold }}
        }
      </span>
    </div>
    }
  </div>
</div>
